import { render, staticRenderFns } from "./BillingHistoryWrapper.vue?vue&type=template&id=53bf4d50"
import script from "./BillingHistoryWrapper.vue?vue&type=script&lang=js"
export * from "./BillingHistoryWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53bf4d50')) {
      api.createRecord('53bf4d50', component.options)
    } else {
      api.reload('53bf4d50', component.options)
    }
    module.hot.accept("./BillingHistoryWrapper.vue?vue&type=template&id=53bf4d50", function () {
      api.rerender('53bf4d50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/billingHistory/BillingHistoryWrapper.vue"
export default component.exports